import actionTypes from "../../actionTypes"

export const setDefaultPrice = data => {
    return {
        type: actionTypes.setDefaultPrice,
        payload: data ? data : {}
    }
}
export const saveShippingList = data => {
    return {
        type: actionTypes.saveShippingList,
        payload: data
    }
}
export const setShippingCounts = data => {
    return {
        type: actionTypes.setShippingCounts,
        payload: data
    }
}
export const setUpdateShipping = data => {
    return {
        type: actionTypes.setUpdateShipping,
        payload: data
    }
}
export const setFetching = data => {
    return {
        type: actionTypes.setFetching,
        payload: data
    }
}
export const updateTitle = data => {
    return {
        type: actionTypes.updateTitle,
        payload: data
    }
}
export const setDeleted = data => {
    return {
        type: actionTypes.setDeleted,
        payload: data
    }
}
export const saveFreeShippingRule = data => {
    return {
        type: actionTypes.saveFreeShippingRule,
        payload: data ? data : {}
    }
}
export const saveFreeProducts = data => {
    return {
        type: actionTypes.saveFreeProducts,
        payload: data ? data : []
    }
}
export const setOpenWidget = data => {
    return {
        type: actionTypes.setOpenWidget,
        payload: data
    }
}